import { render, staticRenderFns } from "./UserVideosReveals.vue?vue&type=template&id=24662228&"
import script from "./UserVideosReveals.vue?vue&type=script&lang=js&"
export * from "./UserVideosReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports